module.exports = __webpack_public_path__ + "static/img/sex0.09e4b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sex0.png
// module id = YL01
// module chunks = 1